import ViewEventModal from './ViewEventModal';

export default ViewEventModal;
